import { Block } from 'baseui/block';
// types
import { ISP_AirDuct } from './types'
// components
import { ValuePanelIcon } from '../../Devices/SensorAnalog'

// api
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { useStyletron } from 'baseui';
import { HorizontalStackPanel } from '../../../components/Layout/StackPanel';



export function SmallPanel(props: ISP_AirDuct) {
    const [,theme] = useStyletron()
    const { children: childElements} = useGetObjectsChildren(props.resourceGroupId,props.id)

    const temperature = childElements?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.TemperatureSensor");
    const humidity = childElements?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.HumiditySensor");
    const pressure = childElements?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.PressureSensor");


    return (
        <HorizontalStackPanel $alignItems={'center'} $gap={theme.sizing.scale200}>
            {temperature &&
                <ValuePanelIcon key={temperature.id}   {...temperature}></ValuePanelIcon>
            }
            {humidity &&

                <ValuePanelIcon  key={humidity.id}    {...humidity}></ValuePanelIcon>
            }
            {pressure &&
                <ValuePanelIcon  key={pressure.id}    {...pressure}></ValuePanelIcon>
            }
        </HorizontalStackPanel>
    );
}